module.exports = __webpack_public_path__ + "img/trivialgeo@3x.7e55c83e.png";